import { ReactElement } from 'react';
import { ValueType } from 'react-select';
import { Header } from '@designSystem/typings';
import Lang from '@lang/en';
import Button from '@root/src/app/designSystem/buttons';
import { CloseMark } from '@root/src/assets/images';
import DropDown from '@designSystem/dropDown';
import { SelectOption } from '@app/common/types';
import IconTile from './iconTile';
import {
  CalendarIcon,
  EnvelopeIcon,
  OpenBookIcon,
  TileUserIcon,
} from '../../../assets/images';
import {
  ActionRow,
  Container,
  HeaderRow,
  Row,
  StyledDropDownWrapper,
  StyledInput,
} from './styles';
import { EditPersonalProps } from './editPersonal';

const EditOrderDesktopPersonal = ({
  handleClose,
  handleSavePersonalInformation,
  personalRegisteredFields,
  errors,
  months,
  currentValueMonth,
  handleChangeMonth,
  docTypes,
  currentValueDocType,
  handleChangeDocType,
  isOrderStatusDone,
}: EditPersonalProps): ReactElement => {
  const handleSubmit = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    handleSavePersonalInformation && handleSavePersonalInformation(event);
  };

  return (
    <Container>
      <HeaderRow>
        <Header data-testid="healthcheck-order-edit-modal-header">
          {Lang.healthCheckEditPersonalLabel}
        </Header>
        <CloseMark onClick={handleClose} />
      </HeaderRow>
      <Row>
        <IconTile
          icon={<TileUserIcon />}
          label={Lang.healthCheckEditOrderNameLabel}
        />
        <StyledInput
          registered={personalRegisteredFields?.nameFirstField}
          label={Lang.healthCheckEditOrderFirstNameLabel}
          errorMessage={errors?.firstName?.message}
          disabled={isOrderStatusDone}
        />
        <StyledInput
          registered={personalRegisteredFields?.nameLastField}
          label={Lang.healthCheckEditOrderLastNameLabel}
          errorMessage={errors?.lastName?.message}
          disabled={isOrderStatusDone}
        />
      </Row>
      <Row>
        <IconTile
          icon={<CalendarIcon />}
          label={Lang.healthCheckEditOrderBirthdateLabel}
        />
        <StyledInput
          widthOverride="104px"
          registered={personalRegisteredFields?.birthdateDayField}
          label={Lang.healthCheckEditOrderDayLabel}
          errorMessage={errors?.birthdateDay?.message}
          disabled={isOrderStatusDone}
        />
        <StyledDropDownWrapper>
          <DropDown
            options={months}
            onChange={(e: ValueType<SelectOption, false>): void =>
              handleChangeMonth(e)
            }
            label={Lang.healthCheckEditOrderMonthLabel}
            registered={personalRegisteredFields?.birthdateMonthField}
            value={currentValueMonth}
            isDisabled={isOrderStatusDone}
          />
        </StyledDropDownWrapper>
        <StyledInput
          widthOverride="104px"
          registered={personalRegisteredFields?.birthdateYearField}
          label={Lang.healthCheckEditOrderYearLabel}
          errorMessage={errors?.birthdateYear?.message}
          disabled={isOrderStatusDone}
        />
      </Row>
      <Row>
        <IconTile
          icon={<OpenBookIcon />}
          label={Lang.healthCheckEditOrderDocumentLabel}
        />
        <StyledDropDownWrapper>
          <DropDown
            options={docTypes}
            onChange={(event: ValueType<SelectOption, false>): void =>
              handleChangeDocType(event)
            }
            label={Lang.healthCheckEditOrderDocumentTypeLabel}
            registered={personalRegisteredFields?.birthdateMonthField}
            value={currentValueDocType}
            isDisabled={isOrderStatusDone}
          />
        </StyledDropDownWrapper>
        <StyledInput
          registered={personalRegisteredFields?.documentNumberField}
          label={Lang.healthCheckEditOrderDocumentNumberLabel}
          errorMessage={errors?.documentNumber?.message}
          disabled={isOrderStatusDone}
        />
      </Row>
      <Row>
        <IconTile
          icon={<EnvelopeIcon />}
          label={Lang.healthCheckEditOrderContactLabel}
        />
        <StyledInput
          widthOverride="328px"
          registered={personalRegisteredFields?.contactEmailField}
          label={Lang.healthCheckEditOrderContactEmailLabel}
          errorMessage={errors?.contactEmail?.message}
        />
      </Row>
      <ActionRow>
        <Button onClick={handleClose} type="tertiary" label={Lang.cancelText} />
        <Button
          data-testid="healthcheck-order-edit-modal-save-button"
          onClick={(event) => handleSubmit(event)}
          label={Lang.saveText}
        />
      </ActionRow>
    </Container>
  );
};

export default EditOrderDesktopPersonal;
